// extracted by mini-css-extract-plugin
module.exports = {"relatedArticlesContainer":"GuideFooter_relatedArticlesContainer__wOUtG","chapters":"GuideFooter_chapters__ok_2S","shimmer":"GuideFooter_shimmer__YvBBJ"};